/**
 * @fileoverview Hook que registra un voto contra el backend y
 * actualiza el contexto local.
 */

import { useState } from "react";

import { useParticipacion } from "../context/ParticipacionContext";
import { registrarVoto } from "../lib/api";

/**
 * @returns {{
 *   enviarVoto: (statement_id: string, valor: import("../lib/schemas").ValorVotoTipo) => Promise<boolean>,
 *   enviando: boolean,
 *   ultimoError: string | null,
 * }}
 */
export function useVotos() {
    const { dispatch } = useParticipacion();
    const [enviando, setEnviando] = useState(false);
    const [ultimoError, setUltimoError] = useState(/** @type {string | null} */ (null));

    /**
     * @param {string} statement_id
     * @param {import("../lib/schemas").ValorVotoTipo} valor
     * @returns {Promise<boolean>}
     */
    async function enviarVoto(statement_id, valor) {
        setEnviando(true);
        setUltimoError(null);
        try {
            await registrarVoto(statement_id, valor);
            dispatch({ type: "SET_VOTO", payload: { statement_id, valor } });
            setEnviando(false);
            return true;
        } catch (e) {
            // @ts-ignore code está en ApiError
            setUltimoError(e?.code || "error_voto");
            setEnviando(false);
            return false;
        }
    }

    return { enviarVoto, enviando, ultimoError };
}
